import * as React from "react";
import styled from "styled-components";
import { content } from "@glossy/theme";

const Container = styled.div`
  position: relative;
  height: 400px;
`;

const CenteredContent = styled.div`
  color: ${(props) => content(props, "secondary")};
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  transform: translateY(-50%);
  font-size: 22px;
`;

interface IProps {
  label: string;
}

const NavigationSwitcherTabs = ({ label }: IProps) => {
  return (
    <Container>
      <CenteredContent>{label}</CenteredContent>
    </Container>
  );
};

export default NavigationSwitcherTabs;
